/**

Copyright (c) 2018, MOBICOOP. All rights reserved.
This project is dual licensed under AGPL and proprietary licence.

This program is free software: you can redistribute it and/or modify
it under the terms of the GNU Affero General Public License as
published by the Free Software Foundation, either version 3 of the
License, or (at your option) any later version.
This program is distributed in the hope that it will be useful,
but WITHOUT ANY WARRANTY; without even the implied warranty of
MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE. See the
GNU Affero General Public License for more details.
You should have received a copy of the GNU Affero General Public License
along with this program. If not, see gnu.org/licenses.

Licence MOBICOOP described in the file
LICENSE
**************************/

<template>
  <ion-page class="ion-page">
    <ion-header class="ion-no-border">
      <ion-toolbar color="primary">
        <ion-buttons slot="start">
          <ion-back-button default-href="/carpools/home"></ion-back-button>
        </ion-buttons>
        <h1 class="ion-text-center">{{ $t('DetailCarpool.title')}}</h1>
      </ion-toolbar>
    </ion-header>

    <ion-content color="primary" forceOverscroll="false">
      <div class="mc-white-container">
        <div class="ion-text-center">
          <ion-icon
            size="large"
            color="primary"
            class="rotating"
            v-if="!carpoolRecap"
            name="sync"
          ></ion-icon>
        </div>

        <div class="ion-text-center" v-if="carpoolRecap && this.fromMessage">
          <ion-badge color="secondary" style="white-space: normal">
            <div v-if="askFromMessage.askStatus == 2">{{ $t('DetailCarpool.askSend')}}</div>
            <div v-if="askFromMessage.askStatus == 3">{{ $t('DetailCarpool.askSend')}}</div>
            <div v-if="askFromMessage.askStatus == 4">{{ $t('DetailCarpool.askAccepted')}}</div>
            <div v-if="askFromMessage.askStatus == 5">{{ $t('DetailCarpool.askAccepted')}}</div>
            <div v-if="askFromMessage.askStatus == 6">{{ $t('DetailCarpool.askDeclined')}}</div>
            <div v-if="askFromMessage.askStatus == 7">{{ $t('DetailCarpool.askDeclined')}}</div>
          </ion-badge>
        </div>

        <RecapCarpool v-if="carpoolRecap" ref="recap" :recap="carpoolRecap" :rdex="true"></RecapCarpool>


         <div v-if="instanceName == 'mobicoop'">
          <br>
          <div class="mobicoop-info-header">{{ $t('DetailCarpool.tipsTitle')}}</div>
          <small>
          <ul>
            <li>{{ $t('DetailCarpool.tip1')}}</li>
            <li>{{ $t('DetailCarpool.tip2')}}</li>
            <li>{{ $t('DetailCarpool.tip3')}}</li>
          </ul>
          </small>
        </div>

        <div
          v-if="carpoolRecap && carpoolRecap.frequency == 2 && fromMessage && askFromMessage.askStatus !== 1 && !!selectedDay"
          class="mc-recap-choose-day"
        >
          <div class="mc-ask-header">{{ $t('DetailCarpool.askFor')}} du {{moment(carpoolRecap.startDate , 'DD/MM/YYYY')}} au {{moment(carpoolRecap.toDate ,'DD/MM/YYYY')}}</div>
          <ion-item v-for="(day, index) in selectedDay" :key="index">

            <div class="mc-choose-day d-flex justify-between">
              <span class="mc-choose-day-title"><b>{{$t(day.trad)}}</b></span>
              <span
                v-if="day.outwardTime"
              >{{ $t('DetailCarpool.outward')}} : {{moment(day.outwardTime, "HH:mm", 'utc')}}</span>
              <span
                v-if="day.returnTime"
              >{{ $t('DetailCarpool.return')}} : {{moment(day.returnTime, "HH:mm", 'utc')}}</span>
            </div>
          </ion-item>
        </div>

        <div class="mc-DetailCarpool-action" v-if="carpoolRecap">
          <div class="d-flex justify-center align-center" v-if="(carpoolSelected.acceptedAsk || carpoolSelected.pendingAsk) && !this.fromMessage">
            <ion-icon name="warning" size="large" color="warning" class="ion-margin-end"></ion-icon>
            <ion-text color="warning">{{ $t('DetailCarpool.alreadyAsk')}}</ion-text>
          </div>

          <ion-button
            v-if="true"
            class="mc-big-button"
            color="primary"
            expand="block"
            @click="goToDetailRdex()"
          >
              <span>
                <ion-icon name="open" class="ion-padding-end"></ion-icon>
                Contacter sur {{ carpoolSelected.externalProvider}}
              </span>
          </ion-button>

          <ion-button
            class="mc-big-button"
            color="primary"
            expand="block"
            fill="outline"
            :disabled="contactLoader || ownAd"
            v-on:click="contact()"
            id="contactButton"
          >
              <span v-if="!contactLoader">
                <ion-icon name="mail" class="ion-padding-end"></ion-icon>
                {{ $t('DetailCarpool.contact') }}
              </span>
            <ion-icon  v-if="contactLoader" color="primary" size="large" class="rotating" name="sync"></ion-icon>
          </ion-button>

            <ion-button
              v-if="true"
              :disabled="ownAd"
              class="mc-big-button ion-text-wrap"
              color="success"
              expand="block"
              v-on:click="askCarpool()"
            >
              <ion-icon
                size="large"
                color="background"
                class="rotating"
                v-if="$store.state.carpoolStore.statusCarpoolAskPost == 'loading'"
                name="sync"
              ></ion-icon>
              <div v-if="$store.state.carpoolStore.statusCarpoolAskPost != 'loading'">
                <ion-icon name="checkmark" class="ion-padding-end hidden-xs"></ion-icon>
                {{ $t('DetailCarpool.askAsPassenger') }}
              </div>
            </ion-button>
        </div>

        <!--

        <ion-button class="mc-big-button" color="danger" expand="block" v-if="carpoolRecap && !ownAd" v-on:click="redirectToContact()">
          <ion-icon name="warning" class="ion-padding-end"></ion-icon>
          {{ $t('DetailCarpool.report')}}
        </ion-button>

        -->
      </div>
    </ion-content>
  </ion-page>
</template>

<style lang="scss">
.mc-DetailCarpool-action {
  margin-top: 50px;
}

.mc-recap-choose-day {
  background: rgba(var(--ion-color-primary-rgb), 0.1);
  border-radius: 20px;
  padding: 20px;
  color: var(--ion-color-primary);
  margin-top: 20px;
  .mc-ask-header {
    background: #f5f6fa;
    text-align: center;
    font-weight: bold;
    padding: 10px;
  }
  .mc-choose-day {
    font-size: 12px;
    width: 100%;
    color: var(--ion-color-primary);

    .mc-choose-day-title {
      min-width: 60px;
    }
  }
}

.mobicoop-info-header {
  margin-right: -20px;
  margin-left: -20px;
  padding: 10px;
  background-color: var(--ion-color-secondary);
  color: white;
  text-align: center;
}


</style>

<script>
import { toast } from "../../Shared/Mixin/toast.mixin";
import RecapCarpool from "../Shared/Components/RecapCarpool.component";
import RecapCarpoolDTO from "../Shared/RecapCarpoolDTO";
import {alertController} from "@ionic/vue";

export default {
  name: "rdex-search-detail",
  mixins: [toast],
  components: {
    RecapCarpool
  },
  data() {
    return {
      instanceName : process.env.VUE_APP_INSTANCE,
      carpoolSelected: null,
      carpoolRecap: null,
      fromMessage: false,
      askFromMessage: null,
      selectedDay: [],
      contactLoader: false
    };
  },
  created() {
    this.getCarpoolAsk();
    const externalAd = this.$store.state.searchStore.resultExternalAd
    if (!!externalAd && externalAd.id && !externalAd.userId) {
      this.$store.dispatch('claimProposal', externalAd.id);
    }
    const userId = this.$store.state.searchStore.searchObject.userId
    if (userId == null && this.$store.state.searchStore.savedSearchId) {
      this.$store.dispatch('claimProposal', this.$store.state.searchStore.savedSearchId);
    }
  },
  computed: {
    hasPhoneNumber() {
      let result = false;
      if (!!this.carpoolSelected) {
        if (!!this.carpoolSelected && !!this.carpoolSelected.carpooler) {
          if (
            !!this.carpoolSelected.carpooler.phone &&
            this.carpoolSelected.carpooler.phoneDisplay == 2
          ) {
            result = true;
          }
        }
      }

      return result;
    },
    ownAd(){
      return this.$store.getters.userId === this.carpoolSelected.carpooler.id;
    },
    user: {
      get() {
        return this.$store.state.userStore.user;
      }
    },
  },

  methods: {
    async getCarpoolAsk() {

      this.index = this.$route.params.param;
      this.carpoolSelected = this.$store.getters.resultRdex[this.index];

      if (!!this.carpoolSelected) {
        this.carpoolRecap = new RecapCarpoolDTO().fromRdex(this.carpoolSelected)
      } else {
        this.$router.push({ name: "carpoolsHome" });
      }
    },


    goToDetailRdex() {
      window.open(this.carpoolSelected.externalUrl, '_blank');
    },

    contact() {
      alertController
        .create({
          header: "Entrez un message",
          message: "Vous allez entrer en contact avec " + this.carpoolRecap.user.givenName + " Veuillez laisser un message",
          inputs: [
            {
              type: 'textarea',
              name: 'message',
              placeholder: '',
            }
          ],
          buttons: [
            {
              text: 'Annuler',
              role: "cancel",
            },
            {
              text: 'Confirmer',
              cssClass: "mc-bold",
              handler: data => {
                this.postAskCarpool(data.message)
              }
            }
          ]
        })
        .then(a => a.present());
    },

    askCarpool() {
      alertController
        .create({
          header: "Confirmer la demande",
          message: "Vous aller faire une demande de covoiturage à " + this.carpoolRecap.user.givenName + " qui pourra accepter ou refuser le covoiturage",
          buttons: [
            {
              text: 'Annuler',
              role: "cancel",
            },
            {
              text: 'Confirmer',
              cssClass: "mc-bold",
              handler: data => {
                  this.postAskCarpool()
              }
            }
          ]
        })
        .then(a => a.present());
    },

    postAskCarpool(message) {
      const post = {
        "driver": {
          "id": 999999999999,
          "externalId": this.carpoolSelected.carpooler.externalJourneyUserId,
          "operator": this.carpoolSelected.externalOrigin,
          "alias": this.carpoolSelected.carpooler.givenName
        },
        "passenger": {
          "id": 999999999999,
          "externalId": this.user.id.toString(),
          "alias": this.user.givenName + ' ' + this.user.shortFamilyName,
          "operator": process.env.VUE_APP_DOMAIN.replace('https://m.', ''),
          "firstName": this.user.givenName,
          "lastName": this.user.familyName
        },
        "passengerPickupDate": new Date(this.carpoolSelected.date).getTime(),
        "passengerPickupLat": Number(this.carpoolSelected.origin.latitude),
        "passengerPickupLng": Number(this.carpoolSelected.origin.longitude),
        "passengerDropLat": Number(this.carpoolSelected.destination.latitude),
        "passengerDropLng": Number(this.carpoolSelected.destination.longitude),
        "passengerPickupAddress": (!!this.carpoolSelected.origin.streetAddress ? this.carpoolSelected.origin.streetAddress + ' '  : '') + this.carpoolSelected.origin.postalCode + ' ' + this.carpoolSelected.origin.addressLocality,
        "passengerDropAddress": (!!this.carpoolSelected.destination.streetAddress ? this.carpoolSelected.destination.streetAddress + ' '  : '') + this.carpoolSelected.destination.postalCode + ' ' + this.carpoolSelected.destination.addressLocality,
        "status": "WAITING_CONFIRMATION",
        "price": {
          "id": 999999999999,
          "type": "UNKNOWN",
          "amount": Number(this.carpoolSelected.roundedPrice)
        },
        "driverJourneyId": this.carpoolSelected.externalJourneyId
      };

      if (message) {
        post.message = message;
      }

        this.$store
          .dispatch("postInterop", post)
          .then(res => {
            this.presentToast(this.$t("AskCarpool.success"), "success");

            this.$router.push({ name: "messages" });
          })
          .catch(err => {
            this.presentToast(this.$t("Commons.error"), "danger");
        });
      }
    },
};
</script>
